/// <reference path="../../../../Scripts/typings/breeze/breeze.d.ts" />
var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
define('areas/organizationmanager/services/organizationsrepository',["require", "exports", "models/breeze", "services/settings"], function (require, exports, Data, Configuration) {
    "use strict";
    var OrganizationRepository = (function (_super) {
        __extends(OrganizationRepository, _super);
        function OrganizationRepository() {
            var serviceUrl = Configuration.Settings.getApiFor("breeze/organization");
            _super.call(this, serviceUrl);
        }
        OrganizationRepository.prototype.onMetadataRequested = function (store) {
            this.addOrganizationType(store);
        };
        OrganizationRepository.prototype.addOrganizationType = function (store) {
            var type = new breeze.ComplexType();
            type.shortName = "OrganizationSummary";
            type.namespace = "AIP.API.SocialNetwork.Model";
            type.addProperty(new breeze.DataProperty({ nameOnServer: "Id", dataType: breeze.DataType.Guid, isNullable: false, isPartOfKey: true }));
            type.addProperty(new breeze.DataProperty({ nameOnServer: "Name", dataType: breeze.DataType.String, isNullable: true, isPartOfKey: false }));
            type.addProperty(new breeze.DataProperty({ nameOnServer: "OrganizationType", dataType: breeze.DataType.Int32, isNullable: true, isPartOfKey: false }));
            type.addProperty(new breeze.DataProperty({ nameOnServer: "ParentName", dataType: breeze.DataType.String, isNullable: true, isPartOfKey: false }));
            type.addProperty(new breeze.DataProperty({ nameOnServer: "ClientCount", dataType: breeze.DataType.Int32, isNullable: true, isPartOfKey: false }));
            type.addProperty(new breeze.DataProperty({ nameOnServer: "MemberCount", dataType: breeze.DataType.Int32, isNullable: true, isPartOfKey: false }));
            type.addProperty(new breeze.DataProperty({ nameOnServer: "ExternalKey", dataType: breeze.DataType.String, isNullable: true, isPartOfKey: false }));
            type.addProperty(new breeze.DataProperty({ nameOnServer: "Uri", dataType: breeze.DataType.String, isNullable: true, isPartOfKey: false }));
            type.addProperty(new breeze.DataProperty({ nameOnServer: "ServerName", dataType: breeze.DataType.String, isNullable: true, isPartOfKey: false }));
            type.addProperty(new breeze.DataProperty({ nameOnServer: "DatabaseName", dataType: breeze.DataType.String, isNullable: true, isPartOfKey: false }));
            store.addEntityType(type);
        };
        return OrganizationRepository;
    }(Data.BreezeRepository));
    exports.OrganizationRepository = OrganizationRepository;
});

